import { Routes } from '@angular/router';
import { ContexpageComponent } from '../contexpage/components/contexpage/contexpage.component';

export const generalRoutes: Routes = [
    { path: 'forsikringsoversigt', component: ContexpageComponent },
    { path: 'forsikringstilbud', component: ContexpageComponent },
    { path: 'forsikring-studerende', component: ContexpageComponent },
    { path: 'ungdomsforsikring', component: ContexpageComponent },
];
